import {match, Pattern} from 'ts-pattern';

import type {PriceBasis} from '@dms/api/new-vehicle';

export type ConfiguratorPriceState =
  | {kind: 'known'; basis: PriceBasis}
  | {kind: 'loading'}
  | {kind: 'unavailable'; displayBasis: PriceBasis};

// Display basis for the whole saved-price presentation when the tenant basis cannot be loaded:
// saved gross with net as secondary text and the snapshot VAT rate in the caption. Not a tenant default (D86 is
// resolved by the backend), and never used while the bundle is loading.
const BUNDLE_UNAVAILABLE_DISPLAY_BASIS: PriceBasis = 'gross';

export function getConfiguratorPriceState(
  basis: PriceBasis | undefined,
  isBundleError: boolean
): ConfiguratorPriceState {
  return match({basis, isBundleError})
    .with({basis: Pattern.nonNullable}, ({basis: knownBasis}) => ({
      kind: 'known' as const,
      basis: knownBasis,
    }))
    .with({isBundleError: true}, () => ({
      kind: 'unavailable' as const,
      displayBasis: BUNDLE_UNAVAILABLE_DISPLAY_BASIS,
    }))
    .otherwise(() => ({kind: 'loading' as const}));
}
